"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FONT_SIZES = exports.LINE_HEIGHTS = exports.SPACING_SIZES = exports.GENERAL_COLOR_VALUES = exports.GeneralColorNames = exports.GENERAL_FONT_VALUES = exports.GeneralFontNames = exports.GENERAL_FONT_WEIGHT_VALUES = exports.GeneralFontWeights = void 0;
var GeneralFontWeights;

(function (GeneralFontWeights) {
  GeneralFontWeights[GeneralFontWeights["regular"] = 0] = "regular";
  GeneralFontWeights[GeneralFontWeights["normal"] = 1] = "normal";
  GeneralFontWeights[GeneralFontWeights["semibold"] = 2] = "semibold";
  GeneralFontWeights[GeneralFontWeights["bold"] = 3] = "bold";
  GeneralFontWeights[GeneralFontWeights["extrabold"] = 4] = "extrabold";
  GeneralFontWeights[GeneralFontWeights["light"] = 5] = "light";
})(GeneralFontWeights = exports.GeneralFontWeights || (exports.GeneralFontWeights = {}));

exports.GENERAL_FONT_WEIGHT_VALUES = {
  [GeneralFontWeights.extrabold]: '800',
  [GeneralFontWeights.bold]: '700',
  [GeneralFontWeights.semibold]: '600',
  [GeneralFontWeights.normal]: '500',
  [GeneralFontWeights.regular]: '400',
  [GeneralFontWeights.light]: '300'
};
/**
 * Defined font names.
 */

var GeneralFontNames;

(function (GeneralFontNames) {
  GeneralFontNames["roboto_sana_serif"] = "Roboto, sans-serif";
})(GeneralFontNames = exports.GeneralFontNames || (exports.GeneralFontNames = {}));
/**
 * Available font values.
 */


exports.GENERAL_FONT_VALUES = {
  [GeneralFontNames.roboto_sana_serif]: 'Roboto, sans-serif'
};
/**
 * Defined color names
 */

var GeneralColorNames;

(function (GeneralColorNames) {
  // common colors
  GeneralColorNames["black"] = "black";
  GeneralColorNames["white"] = "white";
  GeneralColorNames["transparent"] = "transparent"; // clarity colors

  GeneralColorNames["gray_500"] = "gray_500";
  GeneralColorNames["black_main"] = "black_main";
  GeneralColorNames["gray_601"] = "gray_601";
  GeneralColorNames["gray_501"] = "gray_501";
  GeneralColorNames["gray_401"] = "gray_401";
  GeneralColorNames["gray_302"] = "gray_302";
  GeneralColorNames["gray_301"] = "gray_301";
  GeneralColorNames["gray_201"] = "gray_201";
  GeneralColorNames["gray_101"] = "gray_101";
  GeneralColorNames["primary_900"] = "primary_900";
  GeneralColorNames["primary_800"] = "primary_800";
  GeneralColorNames["primary_700_main"] = "primary_700_main";
  GeneralColorNames["primary_601"] = "primary_601";
  GeneralColorNames["primary_600"] = "primary_600";
  GeneralColorNames["primary_500"] = "primary_500";
  GeneralColorNames["primary_400"] = "primary_400";
  GeneralColorNames["primary_300"] = "primary_300";
  GeneralColorNames["primary_200"] = "primary_200";
  GeneralColorNames["primary_100"] = "primary_100";
  GeneralColorNames["mellow_success"] = "mellow_success"; // new buyers portal

  GeneralColorNames["blue_300"] = "blue_300";
  GeneralColorNames["red_300"] = "red_300";
  GeneralColorNames["purple_300"] = "purple_300";
  GeneralColorNames["orange_100"] = "orange_100";
  GeneralColorNames["orange_200"] = "orange_200";
  GeneralColorNames["orange_300"] = "orange_300";
  GeneralColorNames["orange_400"] = "orange_400";
  GeneralColorNames["pink_100"] = "pink_100";
  GeneralColorNames["green_300"] = "green_300";
  GeneralColorNames["green_400"] = "green_400";
  GeneralColorNames["beige_100"] = "beige_100";
  GeneralColorNames["beige_200"] = "beige_200";
  GeneralColorNames["beige_300"] = "beige_300";
  GeneralColorNames["beige_400"] = "beige_400";
  GeneralColorNames["gray_502"] = "gray_502";
  GeneralColorNames["gray_602"] = "gray_602";
  GeneralColorNames["gray_702"] = "gray_702";
})(GeneralColorNames = exports.GeneralColorNames || (exports.GeneralColorNames = {}));
/**
 * Available color values.
 */


exports.GENERAL_COLOR_VALUES = {
  // common
  [GeneralColorNames.black]: '#000',
  [GeneralColorNames.white]: '#fff',
  [GeneralColorNames.transparent]: 'transparent',
  // clarity
  [GeneralColorNames.black_main]: '#1c1c1c',
  [GeneralColorNames.gray_601]: '#323231',
  [GeneralColorNames.gray_501]: '#666667',
  [GeneralColorNames.gray_500]: '#919191',
  [GeneralColorNames.gray_401]: '#999999',
  [GeneralColorNames.gray_302]: '#ccd7dc',
  [GeneralColorNames.gray_301]: '#cccccc',
  [GeneralColorNames.gray_201]: '#e5e5e5',
  [GeneralColorNames.gray_101]: '#f4f4f4',
  [GeneralColorNames.primary_900]: '#002db7',
  [GeneralColorNames.primary_800]: '#1245de',
  [GeneralColorNames.primary_700_main]: '#2d5dec',
  [GeneralColorNames.primary_601]: '#416CED',
  [GeneralColorNames.primary_600]: '#5a83ff',
  [GeneralColorNames.primary_500]: '#80a0ff',
  [GeneralColorNames.primary_400]: '#a8beff',
  [GeneralColorNames.primary_300]: '#cbd8ff',
  [GeneralColorNames.primary_200]: '#dae4ff',
  [GeneralColorNames.primary_100]: '#eaefff',
  [GeneralColorNames.mellow_success]: '#cfedd7',
  // buyers portal
  [GeneralColorNames.blue_300]: '#5bc0de',
  [GeneralColorNames.red_300]: '#d9534f',
  [GeneralColorNames.purple_300]: '#856dff',
  [GeneralColorNames.orange_100]: '#fef1e0',
  [GeneralColorNames.orange_200]: '#fbb863',
  [GeneralColorNames.orange_300]: '#d75f1b',
  [GeneralColorNames.orange_400]: '#c54e0b',
  [GeneralColorNames.pink_100]: '#f9d3cf',
  [GeneralColorNames.green_300]: '#10bb69',
  [GeneralColorNames.green_400]: '#2d5c3b',
  [GeneralColorNames.beige_100]: '#f5f7fb',
  [GeneralColorNames.beige_200]: '#f4f7ff',
  [GeneralColorNames.beige_300]: '#e2e2e2',
  [GeneralColorNames.beige_400]: '#d9d9d9',
  [GeneralColorNames.gray_502]: '#494949',
  [GeneralColorNames.gray_602]: '#2d2d2d',
  [GeneralColorNames.gray_702]: '#14121a'
};
exports.SPACING_SIZES = {
  3: '3px',
  6: '6px',
  7: '7px',
  8: '8px',
  12: '12px',
  15: '15px',
  18: '18px',
  24: '24px',
  30: '30px',
  36: '36px',
  42: '42px',
  48: '48px',
  60: '60px',
  96: '96px',
  120: '120px'
};
exports.LINE_HEIGHTS = {
  13: '13px',
  15: '15px',
  18: '18px',
  19: '19px',
  20: '20px',
  21: '21px',
  24: '24px',
  28: '28px',
  30: '30px',
  32: '32px',
  34: '34px',
  36: '36px',
  40: '40px',
  48: '48px',
  54: '54px',
  58: '58px',
  60: '60px',
  74: '74px',
  82: '82px'
};
exports.FONT_SIZES = {
  9: '9px',
  10: '10px',
  11: '11px',
  12: '12px',
  14: '14px',
  16: '16px',
  18: '18px',
  22: '22px',
  36: '36px',
  48: '48px'
};